// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1884":"d037c333","1987":"d037c333","2211":"d037c333","2236":"a1893ba7","2589":"d037c333","3808":"f1c6c765","4553":"77ab36e7","6944":"c001d225"}[chunkId] + ".chunk.css";
};